import React, { useState } from "react";
import "./Loginpop.css";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { postWithoutTokenAPI, getWithTokenAPI } from "../../util/Api";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../../store/auth/action";
import { setWishlist } from '../../store/wishlistSlice';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const LoginPopup = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const fetchUserWishlist = async (token, userId) => {
    try {
      const response = await getWithTokenAPI(token, `/wishlist/find-all?user_id=${userId}`);
      if (response?.statusCode === 200) {
        const wishlistData = response.data?.wishlist || [];
        // Ensure each item has the correct structure
        const formattedWishlist = wishlistData.map(item => ({
          ...item,
          product_id: item.product_id || item._id,
          _id: item._id
        }));
        dispatch(setWishlist(formattedWishlist));
      } else {
        console.warn("Failed to fetch wishlist:", response);
      }
    } catch (error) {
      console.error('Error fetching wishlist:', error);
    }
  };

  const handleLogin = async () => {
    setError("");

    if (!email || !password) {
      setError("Please enter both email and password.");
      return;
    }

    // Email validation
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailPattern.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    try {
      const response = await postWithoutTokenAPI("/user/login", {
        email,
        password,
        role: "user",
      });

      if (response?.statusCode === 200 && response?.data?.access_token) {
        dispatch(loginSuccess(response.data, response.data.access_token));
        
        // Fetch and set wishlist items with user ID
        await fetchUserWishlist(response.data.access_token, response.data._id);
        
        toast.success("Login successful!", {
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setTimeout(() => {
          onClose();
      }, 2000);
        
      } else {
        setError(response?.message || "Login failed. Please check your credentials.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError(err?.message || "Login failed. Please try again later.");
    }
  };

  return (
    <>

      <ToastContainer
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="login-popup-overlay">
        <div className="login-popup">
          <button className="close-btn" onClick={onClose}>✖</button>
          <h2 className="login-title">Sign In</h2>

          <input
            className="login-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            aria-label="Email"
          />

          <div className="password-wrapper">
            <input
              className="login-input"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              aria-label="Password"
            />
            <span className="eye-icon-popup" onClick={togglePasswordVisibility}>
              {showPassword ? <FiEye /> : <FiEyeOff />}
            </span>
            <div className="login-links">
              <div className="remember-section">
                <input type="checkbox" id="remember" />
                <label htmlFor="remember" className="remember-label">Remember me</label>
              </div>
              <Link to="/Forgotphonenumber" state={{ fromForgotPassword: true }} className="forgot-link">Forgot Password</Link>
            </div>


          </div>

          {error && <p className="error-text">{error}</p>}

          <button className="login-button" onClick={handleLogin}>Login</button>

          <div className="signup-link">
            <span>Don't have an account? </span>
            <a href="/creates">Register</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPopup;
